import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'zikata-frontend-auth-action-successful',
  templateUrl: './auth-action-successful.component.html',
  styleUrls: ['./auth-action-successful.component.scss'],
})
export class AuthActionSuccessfulComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() continue = '';

  constructor(
    private router: Router
  ) {

  }

  nav(str?: string) {
    this.router.navigate([str || '/'])
  }

 }
